/**
 * Animated SVG stick figures for exercise demonstrations
 * Each animation shows the basic movement pattern of the exercise
 */

const COLORS = {
  body: '#4a90d9',
  ground: '#666',
  equipment: '#888'
};

export const exerciseAnimations = {
  'pushups': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="85" x2="180" y2="85" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="pushup-figure">
      <!-- Head -->
      <circle cx="160" cy="35" r="8" fill="${COLORS.body}">
        <animate attributeName="cy" values="35;50;35" dur="2s" repeatCount="indefinite"/>
      </circle>
      <!-- Body -->
      <line x1="152" y1="38" x2="80" y2="45" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="38;55;38" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="45;60;45" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Arms -->
      <line x1="140" y1="42" x2="140" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="42;58;42" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="44" x2="110" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="44;58;44" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="80" y1="45" x2="40" y2="50" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;60;45" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="50;65;50" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="40" y1="50" x2="30" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="50;65;50" dur="2s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'hand-release pushups': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="85" x2="180" y2="85" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="hr-pushup-figure">
      <!-- Head -->
      <circle cx="160" cy="35" r="8" fill="${COLORS.body}">
        <animate attributeName="cy" values="35;70;70;35" dur="3s" repeatCount="indefinite"/>
      </circle>
      <!-- Body -->
      <line x1="152" y1="38" x2="80" y2="45" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="38;75;75;38" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="45;78;78;45" dur="3s" repeatCount="indefinite"/>
      </line>
      <!-- Arms - lift off ground in middle -->
      <line x1="140" y1="42" x2="140" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="42;75;75;42" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="140;160;160;140" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="85;75;75;85" dur="3s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="44" x2="110" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="44;75;75;44" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="110;130;130;110" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="85;75;75;85" dur="3s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="80" y1="45" x2="40" y2="50" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;78;78;45" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="50;80;80;50" dur="3s" repeatCount="indefinite"/>
      </line>
      <line x1="40" y1="50" x2="30" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="50;80;80;50" dur="3s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'air squats': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="squat-figure">
      <!-- Head -->
      <circle cx="100" cy="20" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="20;45;20" dur="2s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso -->
      <line x1="100" y1="30" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="30;55;30" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="60;80;60" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Arms (extended forward for balance) -->
      <line x1="100" y1="35" x2="130" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="35;60;35" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="40;60;40" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="35" x2="70" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="35;60;35" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="40;60;40" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Left leg -->
      <line x1="100" y1="60" x2="80" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="60;80;60" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;70;80" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="90;85;90" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="80" y1="90" x2="85" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="80;70;80" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="90;85;90" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="85;80;85" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Right leg -->
      <line x1="100" y1="60" x2="120" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="60;80;60" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="120;130;120" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="90;85;90" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="120" y1="90" x2="115" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="120;130;120" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="90;85;90" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="115;120;115" dur="2s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'lunges': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="lunge-figure">
      <!-- Head -->
      <circle cx="100" cy="20" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="20;40;20" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso -->
      <line x1="100" y1="30" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="30;50;30" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="60;75;60" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms at sides -->
      <line x1="100" y1="35" x2="90" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="35;55;35" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="55;75;55" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="35" x2="110" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="35;55;35" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="55;75;55" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Front leg -->
      <line x1="100" y1="60" x2="130" y2="80" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="60;75;60" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="130;140;130" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="80;75;80" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="130" y1="80" x2="135" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="130;140;130" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="80;75;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="135;145;135" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Back leg -->
      <line x1="100" y1="60" x2="70" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="60;75;60" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="70;55;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="85;100;85" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="70" y1="85" x2="60" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="70;55;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="85;100;85" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="60;50;60" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'pull-ups': `<svg viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg">
    <!-- Pull-up bar -->
    <line x1="40" y1="15" x2="160" y2="15" stroke="${COLORS.equipment}" stroke-width="4"/>
    <line x1="40" y1="15" x2="40" y2="5" stroke="${COLORS.equipment}" stroke-width="3"/>
    <line x1="160" y1="15" x2="160" y2="5" stroke="${COLORS.equipment}" stroke-width="3"/>
    <g id="pullup-figure">
      <!-- Head -->
      <circle cx="100" cy="45" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="45;28;45" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Arms -->
      <line x1="80" y1="17" x2="90" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y2" values="40;25;40" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="120" y1="17" x2="110" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y2" values="40;25;40" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Torso -->
      <line x1="100" y1="55" x2="100" y2="90" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="55;38;55" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="90;70;90" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="100" y1="90" x2="90" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="90;70;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="125;105;125" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="90" x2="110" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="90;70;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="125;105;125" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'deadlift': `<svg viewBox="0 0 200 130" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="125" x2="180" y2="125" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Barbell -->
    <line x1="30" y1="115" x2="170" y2="115" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="y1" values="115;70;115" dur="2.5s" repeatCount="indefinite"/>
      <animate attributeName="y2" values="115;70;115" dur="2.5s" repeatCount="indefinite"/>
    </line>
    <circle cx="35" cy="115" r="12" fill="none" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="cy" values="115;70;115" dur="2.5s" repeatCount="indefinite"/>
    </circle>
    <circle cx="165" cy="115" r="12" fill="none" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="cy" values="115;70;115" dur="2.5s" repeatCount="indefinite"/>
    </circle>
    <g id="deadlift-figure">
      <!-- Head -->
      <circle cx="100" cy="55" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="55;25;55" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso -->
      <line x1="100" y1="65" x2="100" y2="85" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="65;35;65" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="85;65;85" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms to bar -->
      <line x1="100" y1="70" x2="75" y2="110" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="70;40;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="110;65;110" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="70" x2="125" y2="110" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="70;40;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="110;65;110" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="100" y1="85" x2="85" y2="105" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="85;65;85" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="105;85;105" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="85" y1="105" x2="80" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="105;85;105" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="85" x2="115" y2="105" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="85;65;85" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="105;85;105" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="115" y1="105" x2="120" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="105;85;105" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'romanian deadlift': `<svg viewBox="0 0 200 130" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="125" x2="180" y2="125" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Barbell -->
    <line x1="30" y1="70" x2="170" y2="70" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="y1" values="70;105;70" dur="2.5s" repeatCount="indefinite"/>
      <animate attributeName="y2" values="70;105;70" dur="2.5s" repeatCount="indefinite"/>
    </line>
    <circle cx="35" cy="70" r="10" fill="none" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="cy" values="70;105;70" dur="2.5s" repeatCount="indefinite"/>
    </circle>
    <circle cx="165" cy="70" r="10" fill="none" stroke="${COLORS.equipment}" stroke-width="3">
      <animate attributeName="cy" values="70;105;70" dur="2.5s" repeatCount="indefinite"/>
    </circle>
    <g id="rdl-figure">
      <!-- Head -->
      <circle cx="100" cy="25" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="25;50;25" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="cx" values="100;130;100" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso (hinges forward) -->
      <line x1="100" y1="35" x2="100" y2="65" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="35;55;35" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x1" values="100;120;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="100;85;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms holding bar -->
      <line x1="100" y1="40" x2="80" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;115;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="40;60;40" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;85;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;100;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="40" x2="120" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;115;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="40;60;40" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="120;115;120" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;100;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Legs (slight knee bend, mostly straight) -->
      <line x1="100" y1="65" x2="90" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;85;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="90" y1="95" x2="85" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="100" y1="65" x2="110" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;85;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="95" x2="115" y2="125" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
  </svg>`,

  'plank': `<svg viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="70" x2="180" y2="70" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="plank-figure">
      <!-- Head -->
      <circle cx="160" cy="30" r="8" fill="${COLORS.body}">
        <animate attributeName="cy" values="30;32;30" dur="3s" repeatCount="indefinite"/>
      </circle>
      <!-- Body (slight movement for breathing) -->
      <line x1="152" y1="33" x2="60" y2="40" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="33;35;33" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="40;42;40" dur="3s" repeatCount="indefinite"/>
      </line>
      <!-- Arms (forearm plank) -->
      <line x1="140" y1="36" x2="145" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="36;38;36" dur="3s" repeatCount="indefinite"/>
      </line>
      <line x1="145" y1="70" x2="160" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <!-- Legs -->
      <line x1="60" y1="40" x2="35" y2="45" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="40;42;40" dur="3s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="45;47;45" dur="3s" repeatCount="indefinite"/>
      </line>
      <line x1="35" y1="45" x2="30" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;47;45" dur="3s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'side plank': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="side-plank-figure">
      <!-- Head -->
      <circle cx="100" cy="20" r="8" fill="${COLORS.body}"/>
      <!-- Torso (vertical) -->
      <line x1="100" y1="28" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Top arm raised -->
      <line x1="100" y1="35" x2="100" y2="10" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y2" values="10;5;10" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Bottom arm to ground -->
      <line x1="100" y1="60" x2="100" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <!-- Legs stacked -->
      <line x1="100" y1="60" x2="150" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="150" y1="65" x2="170" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
  </svg>`,

  'hollow hold': `<svg viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="70" x2="180" y2="70" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="hollow-figure">
      <!-- Head -->
      <circle cx="140" cy="35" r="8" fill="${COLORS.body}">
        <animate attributeName="cy" values="35;33;35" dur="2s" repeatCount="indefinite"/>
      </circle>
      <!-- Upper body (curved, shoulders off ground) -->
      <path d="M 132 40 Q 100 55 80 50" stroke="${COLORS.body}" stroke-width="4" fill="none" stroke-linecap="round">
        <animate attributeName="d" values="M 132 40 Q 100 55 80 50;M 132 38 Q 100 52 80 48;M 132 40 Q 100 55 80 50" dur="2s" repeatCount="indefinite"/>
      </path>
      <!-- Arms overhead -->
      <line x1="140" y1="38" x2="170" y2="30" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="38;36;38" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="30;28;30" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Legs raised -->
      <line x1="80" y1="50" x2="50" y2="45" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="50;48;50" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="45;43;45" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="50" y1="45" x2="30" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;43;45" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="40;38;40" dur="2s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'mountain climbers': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="mc-figure">
      <!-- Head -->
      <circle cx="155" cy="30" r="8" fill="${COLORS.body}"/>
      <!-- Body -->
      <line x1="148" y1="35" x2="90" y2="50" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms -->
      <line x1="140" y1="38" x2="145" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="42" x2="115" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <!-- Alternating legs -->
      <line x1="90" y1="50" x2="120" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="120;60;120" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="55;75;55" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="120" y1="55" x2="130" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="120;60;120" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="55;75;55" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="130;50;130" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="90" y1="50" x2="60" y2="75" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="60;120;60" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="75;55;75" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="60" y1="75" x2="50" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="60;120;60" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="75;55;75" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="50;130;50" dur="0.8s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'step-ups': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Box -->
    <rect x="100" y="80" width="60" height="35" fill="none" stroke="${COLORS.equipment}" stroke-width="2"/>
    <g id="stepup-figure">
      <!-- Head -->
      <circle cx="90" cy="30" r="10" fill="${COLORS.body}">
        <animate attributeName="cx" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="cy" values="30;10;30" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso -->
      <line x1="90" y1="40" x2="90" y2="70" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="x1" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="40;20;40" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms -->
      <line x1="90" y1="45" x2="80" y2="60" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="45;25;45" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;120;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="60;40;60" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Stepping leg -->
      <line x1="90" y1="70" x2="110" y2="80" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="110;130;110" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="80;50;80" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="80" x2="120" y2="80" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="110;130;110" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="80;50;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="120;130;120" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="80;80;80" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Standing leg -->
      <line x1="90" y1="70" x2="80" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="90;130;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;120;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="95;50;95" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="80" y1="95" x2="75" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="80;120;80" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="95;50;95" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="75;120;75" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="115;80;115" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'box step-ups': null, // Will use step-ups animation

  'bulgarian split squats': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Bench -->
    <rect x="130" y="85" width="50" height="15" fill="none" stroke="${COLORS.equipment}" stroke-width="2"/>
    <g id="bss-figure">
      <!-- Head -->
      <circle cx="80" cy="25" r="10" fill="${COLORS.body}">
        <animate attributeName="cy" values="25;45;25" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso -->
      <line x1="80" y1="35" x2="80" y2="65" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="35;55;35" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms at sides -->
      <line x1="80" y1="40" x2="70" y2="60" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="40;60;40" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="60;80;60" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Front leg -->
      <line x1="80" y1="65" x2="70" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="70;60;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="90;85;90" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="70" y1="90" x2="65" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="70;60;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="90;85;90" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="65;55;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Back leg on bench -->
      <line x1="80" y1="65" x2="120" y2="75" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="65;80;65" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="75;82;75" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="120" y1="75" x2="145" y2="85" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="75;82;75" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'single leg glute bridges': `<svg viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="70" x2="180" y2="70" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="glute-bridge-figure">
      <!-- Head on ground -->
      <circle cx="160" cy="62" r="8" fill="${COLORS.body}"/>
      <!-- Upper back on ground -->
      <line x1="152" y1="65" x2="130" y2="68" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Hips raised -->
      <line x1="130" y1="68" x2="100" y2="45" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y2" values="45;35;45" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Planted leg -->
      <line x1="100" y1="45" x2="80" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;35;45" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="80" y1="55" x2="75" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <!-- Raised leg -->
      <line x1="100" y1="45" x2="60" y2="35" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="45;35;45" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="35;25;35" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="60" y1="35" x2="40" y2="30" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="y1" values="35;25;35" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="30;20;30" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Arms on ground -->
      <line x1="130" y1="68" x2="140" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
  </svg>`,

  'single-leg rdls': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="sl-rdl-figure">
      <!-- Head -->
      <circle cx="100" cy="30" r="10" fill="${COLORS.body}">
        <animate attributeName="cx" values="100;140;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="cy" values="30;55;30" dur="2.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Torso (hinges forward) -->
      <line x1="100" y1="40" x2="100" y2="70" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="x1" values="100;130;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="40;60;40" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="100;90;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="70;75;70" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms reaching down -->
      <line x1="100" y1="45" x2="95" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;125;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="45;65;45" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="95;100;95" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="70;100;70" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <!-- Standing leg -->
      <line x1="100" y1="70" x2="95" y2="92" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;90;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="70;75;70" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="95" y1="92" x2="90" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <!-- Raised leg (extends back) -->
      <line x1="100" y1="70" x2="70" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;90;100" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="70;75;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;60;65" dur="2.5s" repeatCount="indefinite"/>
      </line>
      <line x1="70" y1="65" x2="50" y2="60" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="70;50;70" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="65;60;65" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="50;30;50" dur="2.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="60;55;60" dur="2.5s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'band rows': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Band anchor point -->
    <circle cx="30" cy="60" r="5" fill="${COLORS.equipment}"/>
    <!-- Resistance band -->
    <line x1="30" y1="60" x2="80" y2="55" stroke="#e74c3c" stroke-width="2">
      <animate attributeName="x2" values="80;60;80" dur="2s" repeatCount="indefinite"/>
    </line>
    <line x1="30" y1="60" x2="80" y2="65" stroke="#e74c3c" stroke-width="2">
      <animate attributeName="x2" values="80;60;80" dur="2s" repeatCount="indefinite"/>
    </line>
    <g id="band-row-figure">
      <!-- Head -->
      <circle cx="120" cy="30" r="10" fill="${COLORS.body}"/>
      <!-- Torso (slightly leaned forward) -->
      <line x1="120" y1="40" x2="110" y2="75" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms pulling band -->
      <line x1="115" y1="50" x2="80" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="80;100;80" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="115" y1="60" x2="80" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="80;100;80" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="110" y1="75" x2="100" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="100" y1="95" x2="95" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="110" y1="75" x2="120" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="95" x2="125" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
  </svg>`,

  'band face pulls': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Band anchor point (high) -->
    <circle cx="30" cy="30" r="5" fill="${COLORS.equipment}"/>
    <!-- Resistance band -->
    <line x1="30" y1="30" x2="80" y2="35" stroke="#e74c3c" stroke-width="2">
      <animate attributeName="x2" values="80;110;80" dur="2s" repeatCount="indefinite"/>
      <animate attributeName="y2" values="35;30;35" dur="2s" repeatCount="indefinite"/>
    </line>
    <g id="face-pull-figure">
      <!-- Head -->
      <circle cx="130" cy="30" r="10" fill="${COLORS.body}"/>
      <!-- Torso -->
      <line x1="130" y1="40" x2="130" y2="75" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms pulling to face -->
      <line x1="130" y1="45" x2="100" y2="35" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="100;120;100" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="35" x2="80" y2="35" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="100;120;100" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;110;80" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Legs -->
      <line x1="130" y1="75" x2="120" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="95" x2="115" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="130" y1="75" x2="140" y2="95" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="140" y1="95" x2="145" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
  </svg>`,

  // Running exercises - show running motion
  '400m': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Track lanes suggestion -->
    <line x1="20" y1="85" x2="180" y2="85" stroke="${COLORS.ground}" stroke-width="1" stroke-dasharray="5,5"/>
    <g id="runner">
      <!-- Head -->
      <circle cx="100" cy="25" r="8" fill="${COLORS.body}"/>
      <!-- Torso (leaning forward) -->
      <line x1="100" y1="33" x2="95" y2="55" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms pumping -->
      <line x1="97" y1="38" x2="85" y2="50" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="85;110;85" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="50;45;50" dur="0.5s" repeatCount="indefinite"/>
      </line>
      <line x1="97" y1="38" x2="110" y2="45" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="110;85;110" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="45;50;45" dur="0.5s" repeatCount="indefinite"/>
      </line>
      <!-- Legs running -->
      <line x1="95" y1="55" x2="75" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="75;115;75" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="70;65;70" dur="0.5s" repeatCount="indefinite"/>
      </line>
      <line x1="75" y1="70" x2="70" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="75;115;75" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="70;65;70" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="70;120;70" dur="0.5s" repeatCount="indefinite"/>
      </line>
      <line x1="95" y1="55" x2="115" y2="65" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="115;75;115" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="65;70;65" dur="0.5s" repeatCount="indefinite"/>
      </line>
      <line x1="115" y1="65" x2="120" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="115;75;115" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="65;70;65" dur="0.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="120;70;120" dur="0.5s" repeatCount="indefinite"/>
      </line>
    </g>
    <text x="100" y="12" text-anchor="middle" font-size="10" fill="${COLORS.equipment}">400m</text>
  </svg>`,

  '800m': null, // Use 400m animation
  '200m': null, // Use 400m animation

  'tempo run': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="tempo-runner">
      <!-- Head -->
      <circle cx="100" cy="28" r="8" fill="${COLORS.body}"/>
      <!-- Torso (more upright for tempo) -->
      <line x1="100" y1="36" x2="100" y2="58" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms pumping (slower) -->
      <line x1="100" y1="42" x2="88" y2="52" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="88;112;88" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="42" x2="112" y2="48" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="112;88;112" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <!-- Legs (moderate stride) -->
      <line x1="100" y1="58" x2="85" y2="75" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="85;115;85" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="85" y1="75" x2="80" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="85;115;85" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="80;118;80" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="58" x2="115" y2="72" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="115;85;115" dur="0.8s" repeatCount="indefinite"/>
      </line>
      <line x1="115" y1="72" x2="118" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="115;85;115" dur="0.8s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="118;80;118" dur="0.8s" repeatCount="indefinite"/>
      </line>
    </g>
    <text x="100" y="12" text-anchor="middle" font-size="10" fill="${COLORS.equipment}">TEMPO</text>
  </svg>`,

  'ruck': `<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="115" x2="180" y2="115" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="ruck-figure">
      <!-- Head -->
      <circle cx="100" cy="20" r="10" fill="${COLORS.body}"/>
      <!-- Backpack -->
      <rect x="90" y="32" width="25" height="30" rx="3" fill="${COLORS.equipment}" opacity="0.7"/>
      <!-- Torso -->
      <line x1="100" y1="30" x2="100" y2="65" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms (relaxed walking) -->
      <line x1="100" y1="38" x2="85" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="85;90;85" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="38" x2="88" y2="55" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="88;83;88" dur="1s" repeatCount="indefinite"/>
      </line>
      <!-- Walking legs -->
      <line x1="100" y1="65" x2="90" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="90;110;90" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="90" y1="90" x2="85" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="90;110;90" dur="1s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="85;115;85" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="65" x2="110" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="110;90;110" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="90" x2="115" y2="115" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="110;90;110" dur="1s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="115;85;115" dur="1s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'warm-up': `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
    <g id="warmup-figure">
      <!-- Head -->
      <circle cx="100" cy="25" r="10" fill="${COLORS.body}"/>
      <!-- Torso -->
      <line x1="100" y1="35" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
      <!-- Arms doing arm circles -->
      <line x1="100" y1="40" x2="70" y2="35" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="70;100;130;100;70" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="35;20;35;50;35" dur="2s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="40" x2="130" y2="35" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="130;100;70;100;130" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="35;20;35;50;35" dur="2s" repeatCount="indefinite"/>
      </line>
      <!-- Legs (light jogging) -->
      <line x1="100" y1="60" x2="90" y2="75" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="90;110;90" dur="0.6s" repeatCount="indefinite"/>
      </line>
      <line x1="90" y1="75" x2="85" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="90;110;90" dur="0.6s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="85;115;85" dur="0.6s" repeatCount="indefinite"/>
      </line>
      <line x1="100" y1="60" x2="110" y2="75" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x2" values="110;90;110" dur="0.6s" repeatCount="indefinite"/>
      </line>
      <line x1="110" y1="75" x2="115" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="110;90;110" dur="0.6s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="115;85;115" dur="0.6s" repeatCount="indefinite"/>
      </line>
    </g>
  </svg>`,

  'core circuit': `<svg viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="70" x2="180" y2="70" stroke="${COLORS.ground}" stroke-width="2"/>
    <!-- Crunch motion -->
    <g id="crunch-figure">
      <!-- Head -->
      <circle cx="140" cy="45" r="8" fill="${COLORS.body}">
        <animate attributeName="cy" values="45;35;45" dur="1.5s" repeatCount="indefinite"/>
        <animate attributeName="cx" values="140;130;140" dur="1.5s" repeatCount="indefinite"/>
      </circle>
      <!-- Upper body -->
      <line x1="135" y1="50" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round">
        <animate attributeName="y1" values="50;42;50" dur="1.5s" repeatCount="indefinite"/>
        <animate attributeName="x1" values="135;125;135" dur="1.5s" repeatCount="indefinite"/>
      </line>
      <!-- Arms behind head -->
      <line x1="140" y1="45" x2="155" y2="40" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
        <animate attributeName="x1" values="140;130;140" dur="1.5s" repeatCount="indefinite"/>
        <animate attributeName="y1" values="45;35;45" dur="1.5s" repeatCount="indefinite"/>
        <animate attributeName="x2" values="155;145;155" dur="1.5s" repeatCount="indefinite"/>
        <animate attributeName="y2" values="40;30;40" dur="1.5s" repeatCount="indefinite"/>
      </line>
      <!-- Legs bent -->
      <line x1="100" y1="60" x2="70" y2="50" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
      <line x1="70" y1="50" x2="60" y2="70" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round"/>
    </g>
    <text x="100" y="12" text-anchor="middle" font-size="9" fill="${COLORS.equipment}">CORE</text>
  </svg>`
};

// Easy run / Zone 2 animation (slower, relaxed jogging)
exerciseAnimations['easy run'] = `<svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
  <line x1="20" y1="90" x2="180" y2="90" stroke="${COLORS.ground}" stroke-width="2"/>
  <g id="easy-runner">
    <!-- Head -->
    <circle cx="100" cy="30" r="8" fill="${COLORS.body}"/>
    <!-- Torso (upright, relaxed) -->
    <line x1="100" y1="38" x2="100" y2="60" stroke="${COLORS.body}" stroke-width="4" stroke-linecap="round"/>
    <!-- Arms (relaxed swing) -->
    <line x1="100" y1="44" x2="92" y2="54" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x2" values="92;108;92" dur="1.2s" repeatCount="indefinite"/>
    </line>
    <line x1="100" y1="44" x2="108" y2="50" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x2" values="108;92;108" dur="1.2s" repeatCount="indefinite"/>
    </line>
    <!-- Legs (slow, short stride) -->
    <line x1="100" y1="60" x2="90" y2="76" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x2" values="90;110;90" dur="1.2s" repeatCount="indefinite"/>
    </line>
    <line x1="90" y1="76" x2="88" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x1" values="90;110;90" dur="1.2s" repeatCount="indefinite"/>
      <animate attributeName="x2" values="88;112;88" dur="1.2s" repeatCount="indefinite"/>
    </line>
    <line x1="100" y1="60" x2="110" y2="74" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x2" values="110;90;110" dur="1.2s" repeatCount="indefinite"/>
    </line>
    <line x1="110" y1="74" x2="112" y2="90" stroke="${COLORS.body}" stroke-width="3" stroke-linecap="round">
      <animate attributeName="x1" values="110;90;110" dur="1.2s" repeatCount="indefinite"/>
      <animate attributeName="x2" values="112;88;112" dur="1.2s" repeatCount="indefinite"/>
    </line>
  </g>
  <text x="100" y="12" text-anchor="middle" font-size="9" fill="${COLORS.equipment}">EASY</text>
  <!-- Heart rate indicator -->
  <circle cx="170" cy="30" r="12" fill="none" stroke="#27ae60" stroke-width="2">
    <animate attributeName="r" values="10;12;10" dur="1s" repeatCount="indefinite"/>
  </circle>
  <text x="170" y="34" text-anchor="middle" font-size="8" fill="#27ae60">Z2</text>
</svg>`;

exerciseAnimations['zone 2'] = exerciseAnimations['easy run'];

// Map aliases to existing animations
exerciseAnimations['box step-ups'] = exerciseAnimations['step-ups'];
exerciseAnimations['800m'] = exerciseAnimations['400m'];
exerciseAnimations['200m'] = exerciseAnimations['400m'];

/**
 * Get animation SVG for an exercise
 * @param {string} exerciseKey - The exercise key
 * @returns {string|null} - SVG string or null if not available
 */
export function getExerciseAnimation(exerciseKey) {
  return exerciseAnimations[exerciseKey] || null;
}
